import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import PropTypes from 'prop-types';

const navigationComponents = {
  item: ItemNavigation,
  group: GroupNavigation,
  subMenu: SubNavigation,
};

export const routeProp = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  icon: PropTypes.object,
  items: PropTypes.array,
  type: PropTypes.string.isRequired,
  permissions: PropTypes.array,
});

function Navigation({ route, ...props }) {
  return React.createElement(navigationComponents[route.type] || ItemNavigation, {
    route,
    ...props,
  });
}

Navigation.propTypes = { route: routeProp };

function ItemNavigation({ route, ...props }) {
  const history = useHistory();

  return (
    <Menu.Item key={route.id} icon={route.icon} {...props} onClick={() => history.push(route.link)}>
      {route.name}
    </Menu.Item>
  );
}

ItemNavigation.propTypes = { route: routeProp };

function GroupNavigation({ route, ...props }) {
  return (
    <Menu.ItemGroup key={route.id} icon={route.icon} title={route.name} {...props}>
      {route.items?.map(item => (
        <Navigation key={item.id} route={item} />
      ))}
    </Menu.ItemGroup>
  );
}

GroupNavigation.propTypes = { route: routeProp };

function SubNavigation({ route, ...props }) {
  return (
    <Menu.SubMenu key={route.id} icon={route.icon} title={route.name} {...props}>
      {route?.items?.map(item => (
        <Navigation key={item.id} route={item} />
      ))}
    </Menu.SubMenu>
  );
}

SubNavigation.propTypes = { route: routeProp };

function flattenRoutes(routes = [], state = {}) {
  return routes.reduce(
    (acc, curr) => ({ ...acc, ...(curr.items ? flattenRoutes(curr.items, acc) : { [curr.link]: curr.id }) }),
    state
  );
}

export function Navigations({ routes }) {
  const location = useLocation();
  const flattenedRoutes = useMemo(() => flattenRoutes(routes), []);
  const selectedKey = useMemo(() => flattenedRoutes[location.pathname], [flattenedRoutes, location.pathname]);

  return (
    <Menu mode="horizontal" selectedKeys={[selectedKey]} style={{ flex: 'auto' }}>
      {routes?.map(route => (
        <Navigation key={route.id} route={route} />
      ))}
    </Menu>
  );
}

Navigations.propTypes = { routes: PropTypes.array };
